import MultipleChoiceCheckbox from './MultipleChoiceCheckbox';

export default MultipleChoiceCheckbox;
